import { Box } from '@chakra-ui/react';
import { SWRConfig } from 'swr';
import Sidebar from './sidebar/SideBar';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import ErrorBoundaryClass from 'components/ErrorBoundary';
import useAuth from 'hooks/useAuth';
import { EmptyState, SectionCard } from 'pages/asesoras/components/ui';

function MainLayoutAsesoras(props) {
  const { user } = useAuth();
  // Un usuario con rol asesora pero sin registro de asesora vinculado no puede
  // ver prospectos ni comisiones: se avisa en lugar de fallar en cada página.
  const missingAdviser = user && user.role?.type === 'adviser' && !user.adviser;

  return (
    <>
      <ErrorBoundaryClass>
        <Box>
          <Header />
          <Sidebar>
            <Box padding={{ base: '16px', md: '24px 32px' }} bg="gray.50" minH="calc(100vh - 60px)">
              {missingAdviser ? (
                <SectionCard>
                  <EmptyState
                    title="Tu usuario no tiene una asesora asignada"
                    description="Para ver prospectos, estudiantes y comisiones, pide al administrador que vincule tu usuario con tu registro de asesora."
                  />
                </SectionCard>
              ) : (
                <Outlet />
              )}
            </Box>
          </Sidebar>
        </Box>
      </ErrorBoundaryClass>
    </>
  );
}

export default MainLayoutAsesoras;
